<!-- Bouton dispatch (même style/emplacement que les exports XLS/ISI/IINOV) -->
<button
  type="button"
  pButton
  pRipple
  icon="pi pi-send"
  (click)="openDialog()"
  class="p-button-success mb-2 mr-2"
  pTooltip="Envoyer les ressources vers Max"
  tooltipPosition="bottom"
  data-testid="dispatch-trigger"
></button>

<p-toast key="dispatch" position="top-right"></p-toast>

<!-- Dialog : sélection des structures à dispatcher -->
<p-dialog
  header="Envoi des ressources vers Max"
  [(visible)]="displayStructures"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '420px' }"
>
  <div *ngIf="loadingStructures" class="flex justify-content-center p-4">
    <p-progressSpinner styleClass="w-3rem h-3rem" strokeWidth="4"></p-progressSpinner>
  </div>

  <ng-container *ngIf="!loadingStructures">
    <p *ngIf="structures.length === 0" class="text-color-secondary" data-testid="dispatch-empty">
      Aucune structure dispatchable pour cet ouvrage.
    </p>

    <div *ngIf="structures.length > 0">
      <div class="mb-3">
        <button
          pButton
          type="button"
          label="Tout sélectionner"
          class="p-button-text p-button-sm mr-2"
          (click)="selectAll()"
          data-testid="dispatch-select-all"
        ></button>
        <button
          pButton
          type="button"
          label="Tout désélectionner"
          class="p-button-text p-button-sm"
          (click)="deselectAll()"
          data-testid="dispatch-deselect-all"
        ></button>
      </div>

      <div
        *ngFor="let structure of structures"
        class="field-checkbox mb-2"
        [attr.data-testid]="'dispatch-structure-' + structure"
      >
        <p-checkbox
          name="structures"
          [value]="structure"
          [(ngModel)]="selectedStructures"
          [inputId]="'struct_' + structure"
        ></p-checkbox>
        <label [for]="'struct_' + structure" class="ml-2">{{ structure }}</label>
      </div>
    </div>
  </ng-container>

  <ng-template pTemplate="footer">
    <button
      pButton
      type="button"
      label="Annuler"
      class="p-button-text"
      (click)="displayStructures = false"
      data-testid="dispatch-cancel"
    ></button>
    <button
      pButton
      type="button"
      label="Envoyer"
      icon="pi pi-send"
      class="p-button-success humensis-green"
      [disabled]="selectedStructures.length === 0 || dispatching"
      (click)="send()"
      data-testid="dispatch-send"
    ></button>
  </ng-template>
</p-dialog>

<!-- Modal de progression / recap (bas droite) -->
<div class="dispatch-progress" *ngIf="showProgress" data-testid="dispatch-progress">
  <div class="dispatch-progress__header">
    <span>Envoie des ressources vers Max</span>
    <button
      type="button"
      class="dispatch-progress__close"
      (click)="closeProgress()"
      aria-label="Fermer"
      data-testid="dispatch-close"
    >
      &times;
    </button>
  </div>

  <div class="dispatch-progress__body">
    <p-progressBar [value]="progressPercent"></p-progressBar>

    <div class="dispatch-progress__counts" data-testid="dispatch-counts">
      {{ job?.processed ?? 0 }} / {{ job?.total ?? jobTotal }} traité(s)
      <span class="ok">· {{ job?.successCount ?? 0 }} ✓</span>
      <span class="ko" *ngIf="(job?.failureCount ?? 0) > 0">· {{ job?.failureCount }} ✗</span>
    </div>

    <div *ngIf="job?.done" class="dispatch-progress__recap" data-testid="dispatch-recap">
      <strong>Dispatch terminé</strong>
      <ul class="dispatch-progress__summary">
        <li class="ok">{{ job?.successCount }} succès</li>
        <li class="ko" *ngIf="(job?.failureCount ?? 0) > 0">{{ job?.failureCount }} échec(s)</li>
      </ul>

      <p class="ko" *ngFor="let error of job?.errors">{{ error }}</p>

      <details *ngIf="(job?.failures?.length ?? 0) > 0" class="dispatch-progress__details">
        <summary>Détails des échecs</summary>
        <ul>
          <li *ngFor="let failure of job?.failures">
            <strong>{{ failure.filename || 'ressource #' + failure.id }}</strong> — {{ failure.reason }}
          </li>
        </ul>
      </details>
    </div>
  </div>
</div>
